import { render, staticRenderFns } from "./OtherCostModal.vue?vue&type=template&id=81e35584&"
import script from "./OtherCostModal.vue?vue&type=script&lang=js&"
export * from "./OtherCostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports